import styled from '@emotion/styled'
import Image from 'components/Image'

const RelatedArticlesItemImage = styled(Image)`
    border-radius: 8px;

`

export default RelatedArticlesItemImage